// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'babel-polyfill'
import router from './router'
import store from './store/index' //引入vuex
import './assets/reset.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import echarts from 'echarts'
// import '../static/css/swiper.min.css'
// import '../'
import '../static/css/swiper.min.css'
import VideoPlayer from 'vue-video-player'
import VueAMap from 'vue-amap';
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import getPDF from '@/components/untils/getPDF.js'
Vue.use(getPDF)
Vue.use(VideoPlayer)
Vue.use(VueAwesomeSwiper)
import directive from '@/untils/directive.js'
// 全局注册自定义指令
Object.keys(directive).forEach(item => {
    Vue.directive(item, directive[item])
})
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(ElementUI);
/* eslint-disable no-new */
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    key: 'f2d47abf1be10f99ac4794d036a0fea0',
    plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
    // 默认高德 sdk 版本为 1.4.4
    v: '1.4.4'
});
new Vue({
        el: '#app',
        router,
        store, //使用vuex
        components: { App },
        template: '<App/>'
    })
    // router.beforeEach((to, from, next) => {
    //     // const _token = localStorage.getItem('_token')
    //     // const _role = localStorage.getItem('_role')
    //     // if (_token) {
    //     //     if (_role == 4 && to.path == '/') {
    //     //         console.dir('============topath==============')
    //     //         next('/myAccountPage');
    //     //     } else {
    //     //         console.dir('============topath=========topath==============')
    //     //         next()
    //     //     }
    //     // } else {
    //     //     next('/loginPage');
    //     // }
    // })


// WEBPACK FOOTER //
// ./src/main.js